import { useEffect, useState, useTransition } from "react"
import { ModuleEnum, useLazyGetUtilitiesQuery } from "src/api/modules/utilitize"
import InputAutocomplete from "src/shared/components/input-autocomplete"

interface SelectInvoiceParticularFieldProps {
  value: string
  onChange: (value: string, valueObj: any) => void
  label?: string
  fullWidth?: boolean
  placeholder?: string
  required?: boolean
  helperText?: string
  error?: boolean
  disableClearable?: boolean
}

const SelectInvoiceParticularField = ({
  value,
  onChange,
  label,
  placeholder,
  fullWidth = true,
  required = false,
  helperText,
  disableClearable = false,
  error
}: SelectInvoiceParticularFieldProps) => {
  const [isInvoiceParticularPending, startInvoiceParticularTransition] = useTransition()
  const [invoiceParticular, setInvoiceParticular] = useState<IOptions[]>([])

  const [getUtilities] = useLazyGetUtilitiesQuery()
  const handleGetInvoiceParticular = async () => {
    startInvoiceParticularTransition(async () => {
      const response = await getUtilities({
        page: 1,
        limit: 10000,
        active: true,
        module: ModuleEnum.INVOICE_PARTICULAR
      })
      startInvoiceParticularTransition(() => {
        setInvoiceParticular(
          response.data?.data?.map(item => ({
            value: item.id ?? "",
            label: item.itemName ?? ""
          })) ?? []
        )
      })
    })
  }

  useEffect(() => {
    if (value && !invoiceParticular.length) {
      handleGetInvoiceParticular()
    }
  }, [value])

  return (
    <InputAutocomplete
      label={label}
      loading={isInvoiceParticularPending}
      fullWidth={fullWidth}
      loadingText="Loading Invoice Particular..."
      options={invoiceParticular}
      getOptionLabel={item => item.label ?? ""}
      getOptionKey={item => item.value ?? ""}
      onOpen={() => !invoiceParticular.length && handleGetInvoiceParticular()}
      value={invoiceParticular.find(item => item.value === value)}
      placeholder={placeholder}
      onChange={(value: any) => {
        onChange(value?.value, value)
      }}
      required={required}
      helperText={helperText}
      error={error}
      disableClearable={disableClearable}
    />
  )
}

export default SelectInvoiceParticularField
